export const ACCOUNTS_END_STEP = '16';
export const ENROLLMENT_STEPS = {
  1: 'BMPWELCOME', // Protección de datos
  2: 'BMPASSWORD', // Cambio de password
  3: 'BMCERT', // Certificado
  4: 'BMWELCOME', // Pagína de inicio
  //5: 'SMS' SIGNADOC
  6: 'OTP', // OTP code QR
  7: 'BMEMAIL', // Confirmar/Cambio de e-mail
  //8: deprecated PORTAFIRMAS
  9: 'TOS', // Condiciones de uso
  //10: unknown
  //11: 'TERMS' SIGNADOC
  12: 'VERIFY_OTP', // Verificación por sms
  13: 'EIDAS', // eIDAS enrollment form
  14: 'accounts/ACCOUNTS',
  15: 'accounts/ACCOUNTS_WELCOME',
};
ENROLLMENT_STEPS[ACCOUNTS_END_STEP] = 'accounts/ACCOUNTS_END';
